import { createAuthManager } from '@aleph-alpha/lib-auth';
import { resolveConnectorId } from './connector';

if (!import.meta.env.VITE_IAM_ISSUER) {
  throw new Error('VITE_IAM_ISSUER is not defined');
}

if (!import.meta.env.VITE_IAM_CLIENT_ID) {
  throw new Error('VITE_IAM_CLIENT_ID is not defined');
}

if (!import.meta.env.VITE_APP_URL) {
  throw new Error('VITE_APP_URL is not defined');
}

const connectorId = resolveConnectorId(
  window.location.search,
  import.meta.env.VITE_DEX_CONNECTOR_ID
);

export const authManager = createAuthManager(
  import.meta.env.VITE_IAM_ISSUER,
  import.meta.env.VITE_IAM_CLIENT_ID,
  import.meta.env.VITE_APP_URL,
  '/callback',
  // lib-auth's 5th arg is typed as a full UserManagerSettingsStore, but only
  // extraQueryParams is needed (forwarded to oidc-client-ts at runtime).
  connectorId
    ? ({ extraQueryParams: { connector_id: connectorId } } as unknown as Parameters<
        typeof createAuthManager
      >[4])
    : undefined
);
